import { useQuery } from '@tanstack/react-query';

import { alertsV1ListAlertTypesRetrieve } from '@/api/fe-api/__generated__/oazapfts-client';
import { appConfig } from '@/config';
import { useAuth } from '@/hooks/use-auth';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { useMe } from '@/hooks/use-me';
import { isWarrantyEnabled } from '@/utils/migration/warranty-version';

export function useAlertTypesData() {
  const me = useMe();
  const auth = useAuth();
  const featureFlag = useFeatureFlag();

  return useQuery(
    [
      'alertTypesData',
      me.email,
      me.displayName,
      featureFlag('pcs'),
      featureFlag('warrantyV2'),
      featureFlag('socOffsetViaVoltage'),
    ],
    async () => {
      const accessToken = await auth.getAccessToken();

      const params: any = {
        xUserEmail: me.email,
        xUserName: me.displayName,
        includePcsAlerts: featureFlag('pcs'),
        socOffsetViaVoltage: featureFlag('socOffsetViaVoltage'),
        includeWarrantyAlerts:
          featureFlag('warrantyAlerts') &&
          isWarrantyEnabled(me.config.featureFlags, me.isInternal),
      };

      const response = await alertsV1ListAlertTypesRetrieve(params, {
        baseUrl: `${appConfig.bffUrl}/plex`,
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status !== 200) {
        throw new Error('Failed to fetch alert types');
      }

      return response.data;
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  );
}
